import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/material.css";
import _ from "lodash";
import { loggedInUser } from "../utils/store";
import { useAtom } from "jotai";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { SHARED_COUPON_DETAILS } from "../utils/constants/apiUrl";
import { get } from "../server";
import showToast from "../helpers/showToast";
import { Button, Card } from "react-bootstrap";
import playstore from "../assets/images/google.jpg";
import appstore from "../assets/images/apple.jpg";
import tick from "../assets/images/tick.svg";
import logo from "../assets/images/signup_icons/logo-dark.svg";
import box from "../assets/images/surprise-red-gift-box.png";
import scissors from "../assets/images/scissors.png";

const PublicCouponMessage = () => {
  const [loading, setLoading] = useState(false);
  const [couponDetails, setCouponDetails] = useState(null);
  const [couponMessage, setCouponMessage] = useState("");
  const navigate = useNavigate();
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  const location = useLocation();
  const couponData = location.state?.coupon;
  console.log("location.state-------", location.state);
  console.log(
    "location.state?.setup_guide_url",
    location.state?.coupon?.setup_guide_url
  );
  const guide = location.state?.coupon?.setup_guide_url;

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="public-coupon-page">
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <div className="col-md-5 col-12">
            <Card className="shadow text-center">
              <Card.Body>
                {/* {couponDetails !== null ? ( */}
                <>
                  <img
                    className="d-block mx-auto mb-3"
                    src={tick}
                    alt="success"
                  />
                  <h1>Congratulations! </h1>
                  <p className="subtitle">You’re All Set!</p>
                  <p className="package-text">
                    {couponData?.coupon?.is_payable === true
                      ? `You are eligible for ${
                          couponData?.package_name ||
                          couponData?.coupon?.package_name
                        } Package for
                    1
                    ${
                      couponData?.coupon?.duration_type === "monthly"
                        ? " month"
                        : " year"
                    }. Log in to our web application to purchase the package using the provided coupon code.`
                      : `Your ${
                          couponData?.package_name ||
                          couponData?.coupon?.package_name
                        } Package is unlocked free for
                    1 
                    ${
                      couponData?.coupon?.duration_type === "monthly"
                        ? " month"
                        : " year"
                    }
                    .`}
                  </p>
                  {couponData?.coupon?.is_payable === true && (
                    <div className="coupon-code-wrapper">
                      {`${couponData?.coupon?.coupon_code?.coupon}`}
                      <img src={scissors} alt="" className="" />
                    </div>
                  )}
                  {console.log("couponData", couponData)}
                  {couponData?.coupon?.is_payable === true ? (
                    <Button
                      variant="primary"
                      onClick={() =>
                        navigate(
                          `/login${couponData?.coupon?.coupon_code?.coupon_code_url}`,
                          {
                            state: { couponVal: 99 },
                          }
                        )
                      }
                      className="rounded-pill mb-3"
                    >
                      LOG IN
                    </Button>
                  ) : (
                    <div className="cardFooter mt-0 ">
                      <div className="d-flex align-items-center gap-3 justify-content-center">
                        <a
                          href="https://play.google.com/store/apps/details?id=com.contactco.contactapp"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={playstore} alt="" className="img-fluid" />
                        </a>
                        <a
                          href="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={appstore} alt="" className="img-fluid" />
                        </a>
                      </div>
                    </div>
                  )}
                  <p className="mb-0">
                    {couponData?.coupon?.is_payable === true
                      ? ""
                      : `Log in to our mobile app to start enjoying all the exclusive
                    features.`}
                  </p>
                  <div className="mt-4 text-center">
                    <p>Need a hand getting started?</p>
                    <a
                      href={guide}
                      target="_blank"
                      className="btn btn-link setup-link p-0"
                    >
                      Setup Guide
                    </a>
                  </div>
                </>
                {/* ) : (
                  <h1 className="mb-0">{couponMessage}</h1>
                )} */}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicCouponMessage;
